/**
 * @module geo/payload/facade
 */


import {MapOptions} from '../../types/map';

/**
 * Action to reset current features on one or more layers
 * @since v 2.0.2
 */
export class RESET_SELECTION {
  public map?: MapOptions|null;
  /**
   * List of entry key to empty features from. If undefined, reset features on
   * all layers.
   */
  public layers?: string[];

  /**
   * @param options object with properties values
   */
  constructor(options: any) {
    Object.assign(this, options);
  }
}
